import { render, staticRenderFns } from "./TicketCommentsRich.vue?vue&type=template&id=67abe268"
import script from "./TicketCommentsRich.js?vue&type=script&lang=js&external"
export * from "./TicketCommentsRich.js?vue&type=script&lang=js&external"
import style0 from "./TicketCommentsRich.vue?vue&type=style&index=0&id=67abe268&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports